(ns manatee.qa.handlers
  (:require [ajax.edn :refer [edn-request-format edn-response-format]]
            [kee-frame.core :as kf]
            [manatee.admin.task-config.app-db :as task-db]
            [manatee.annotation.app-db :as annotation-db]
            [manatee.annotation.handlers :as annotation-handlers]
            [manatee.annotation.ids :as annotation-ids]
            [manatee.components.modal.handlers :as modal]
            [manatee.components.notifications.handlers :as notifications]
            [manatee.domain.task :as task]
            [manatee.edit.app-db :as edit-db]
            [manatee.edit.handlers :as edit-handlers]
            [manatee.models.differences :as differences]
            [manatee.qa.app-db :as db]
            [manatee.session.handlers :as session]
            [manatee.user.app-db :as user-db]
            [re-frame.core :as rf]
            [taoensso.timbre :as log]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Item Group ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-controller ::item-group
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::item-group)
                                params))
                    :start (fn [_ {{:keys [user-id item-group-id]} :route-params :as active}]
                             (when active
                               [::load-item-group user-id item-group-id [::load-item-group-success]]))})

(rf/reg-event-fx
 ::load-item-group
 (fn load-item-group
   [_ [_ user-id item-group-id on-success]]
   {:dispatch-n [[::set-qa-loading true]
                 [::clear-item-group]]
    :http-xhrio {:method :get
                 :uri (kf/path-for [:api/item-group
                                    :item-group-id item-group-id])
                 :params {:user-id user-id}
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success on-success
                 :on-failure [::load-item-group-failure]}}))

(rf/reg-event-fx
 ::load-item-group-success
 (fn load-item-group-success
   [{:keys [db]} [_ item-group]]
   {:dispatch-n [(when (= :completed (edit-db/selected-tab db))
                   ;; Only record events that has come through the completed tab
                   [::session/log-events
                    {:events [{:event-type :viewed
                               :data {:item-id (get-in item-group [:part-item :id])
                                      :user-id (user-db/get-user-id db)
                                      :user-role (user-db/get-user-role db)}}]}])
                 [::load-viewed-items-from-item-group item-group]]
    :db (-> db
            (db/set-qa-loading false)
            (db/set-item-group item-group))}))

(rf/reg-event-fx
 ::load-item-group-failure
 (fn load-item-group-failure
   [{:keys [db]} [_ item-group]]
   (log/error "Error loading item-group" item-group)
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Unable to load item group"
                :type :error}
               :auto-dismiss? false]
    :db (db/set-qa-loading db false)}))

(rf/reg-event-db
 ::clear-item-group
 (fn clear-item-group
   [db _]
   (db/clear-item-group db)))

(rf/reg-event-fx
 ::load-viewed-items-from-item-group
 (fn load-viewed-items-from-item-group
   [_ [_ item-group]]
   {:http-xhrio {:method :get
                 :uri (kf/path-for [:api/user-viewed-items])
                 :params {:item-id [(str (get-in item-group [:part-item :id]))]}
                 :response-format (edn-response-format)
                 :on-success [::load-viewed-items-success]}}))

(rf/reg-event-db
 ::load-viewed-items-success
 (fn load-viewed-items-success
   [db [_ {:keys [viewed-items]}]]
   (db/set-viewed-items db viewed-items)))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Answers Items ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
 ::clear-edit
 (fn clear-edit
   [db _]
   (db/clear-edit db)))

(rf/reg-event-fx
 ::init-with-edit-and-item
 (fn init-with-edit-and-item
   [{:keys [db]} _]
   (let [edit (db/get-edit db)
         item (db/get-item db)]
     (when (and edit item)
       {:dispatch [::annotation-handlers/init-edit edit item]}))))

(rf/reg-event-fx
 ::init-with-item
 (fn init-with-item
   [{:keys [db]} _]
   (let [item (db/get-item db)]
     {:dispatch [::annotation-handlers/init-edit nil item]})))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;; Answer Item Edits ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-controller ::user-item-edits
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::user-item-edits)
                                params))
                    :start (fn [_ {{:keys [user-id item-id]} :route-params :as active}]
                             (when active
                               [::load-edit user-id item-id]))})

(rf/reg-event-fx
 ::load-edit
 (fn load-edit
   [_ [_ user-id item-id]]
   {:dispatch-n [[::load-user-item-edits user-id item-id [::load-user-item-edits-success]]
                 [::load-item item-id [::init-with-edit-and-item]]]}))

(rf/reg-event-fx
 ::load-user-item-edits
 (fn load-user-item-edits
   [_ [_ user-id item-id on-success]]
   {:dispatch [::clear-edit]
    :http-xhrio {:method :get
                 :uri (kf/path-for [:api/user-item-edits
                                    :item-id item-id
                                    :user-id user-id])
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success on-success
                 :on-failure [::load-user-item-edits-failure]}}))

(rf/reg-event-fx
 ::load-user-item-edits-success
 (fn load-user-item-edits-success
   [{:keys [db]} [_ edit]]
   {:db (db/set-edit db edit)
    :dispatch-n [[::init-with-edit-and-item]
                 [::session/log-events
                  {:events [{:event-type :viewed
                             :data {:item-id (:item-id edit)
                                    :user-id (user-db/get-user-id db)
                                    :user-role (user-db/get-user-role db)}}]}]]}))

(rf/reg-event-fx
 ::load-user-item-edits-failure
 (fn load-user-item-edits-failure
   [{:keys [db]} [_ response]]
   (log/error "Error loading edit" {:info response
                                    :user-id (user-db/get-user-id db)})))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;; Answer Item Reports ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-controller ::user-item-reports
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::user-item-reports)
                                params))
                    :start (fn [_ {{:keys [user-id item-id]} :route-params :as active}]
                             (when active
                               [::load-edit-with-reports user-id item-id]))})

(rf/reg-event-fx
 ::load-edit-with-reports
 (fn load-edit-with-reports
   [_ [_ user-id item-id]]
   {:dispatch-n [[::load-user-item-reports user-id item-id]
                 [::load-item item-id [::init-with-edit-and-item]]]}))

(rf/reg-event-fx
 ::load-user-item-reports
 (fn load-user-item-reports
   [_ [_ user-id item-id]]
   {:dispatch [::clear-edit]
    :http-xhrio {:method :get
                 :uri (kf/path-for [:api/user-item-reports
                                    :item-id item-id
                                    :user-id user-id])
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::reported-edit-load-success]
                 :on-failure [::reported-edit-load-failure]}}))

(rf/reg-event-fx
 ::reported-edit-load-success
 (fn reported-edit-load-success
   [{:keys [db]} [_ edit]]
   {:db (db/set-edit db edit)
    :dispatch [::init-with-edit-and-item]}))

(rf/reg-event-fx
 ::reported-edit-load-failure
 (fn reported-edit-load-failure
   [_ [_ report]]
   (log/error "Error loading reports" {:report report})
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Unable to load reports"
                :type :error}
               :auto-dismiss? false]}))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;; Answer Item without Edits ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-controller ::item
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::item)
                                params))
                    :start (fn [_ {{:keys [item-id]} :route-params :as active}]
                             (when active
                               [::load-item item-id [::init-with-item]]))})

(rf/reg-event-fx
 ::load-item
 (fn load-item
   [_ [_ item-id on-success]]
   {:dispatch-n [[::set-qa-loading true]
                 [::clear-item]]
    :http-xhrio {:method :get
                 :uri (kf/path-for [:api/item :item-id item-id])
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::load-item-success on-success]
                 :on-failure [::load-item-failure]}}))

(rf/reg-event-fx
 ::load-item-success
 (fn load-item-success
   [{:keys [db]} [_ on-success item]]
   {:db (-> db
            (db/set-qa-loading false)
            (db/set-item item))
    :dispatch-n [on-success]}))

(rf/reg-event-fx
 ::load-item-failure
 (fn load-item-failure
   [{:keys [db]} [_ {:keys [response]
                     :as   _resp}]]
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message (get response :reason "Unable to load item")
                :type    :error}
               :auto-dismiss? true]
    :db       (db/set-qa-loading db false)}))

(rf/reg-event-db
 ::clear-item
 (fn clear-item
   [db _]
   (db/clear-item db)))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;; Compare Answer Item Edits ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-controller ::compare-item-edits
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::compare-item-edits) ; Is this really necessary? Seems like boilerplate.
                                params))
                    :start (fn [_ {{:keys [user-a user-b item-id]} :route-params :as active}]
                             (when active
                               [::load-comparate-edits user-a user-b item-id]))})

(rf/reg-event-fx
 ::load-comparate-edits
 (fn load-comparate-edits
   [{:keys [db]} [_ user-a user-b item-id]]
   {:db (-> db
            (db/set-qa-loading true)
            (db/set-comparate-edits nil))
    :dispatch-n [[::load-user-item-edits user-a item-id [::load-comparate-edit-success :edit-a]]
                 [::load-user-item-edits user-b item-id [::load-comparate-edit-success :edit-b]]
                 [::load-item item-id]]}))

(defn flag-differences-in-comparate-edits
  [{:keys [edit-a edit-b] :as edits} task-config]
  (let [{:keys [field-name]} (task/non-scoring-field task-config)
        edit-a-script (some->> field-name (get edit-a))
        edit-b-script (some->> field-name (get edit-b))
        {:keys [script-a script-b] :as flagged} (when (and edit-a-script edit-b-script)
                                                  (differences/flag-differences
                                                   {:script-a edit-a-script
                                                    :script-b edit-b-script}))]
    (cond-> edits
      flagged (assoc-in [:edit-a field-name] script-a)
      flagged (assoc-in [:edit-b field-name] script-b))))

(defn comparate-edits
  [db which edit]
  (-> (db/get-comparate-edits db)
      (assoc which (assoc edit :submitted-comparate-edit edit))))

(defn on-load-comparate-edit-success
  [db task-config-id edits]
  (let [task-config (task-db/get-task-config db task-config-id)
        flagged-edits (flag-differences-in-comparate-edits edits task-config)]
    {:db (db/set-comparate-edits db flagged-edits)}))

(rf/reg-event-fx
 ::load-comparate-edit-success
 (fn load-comparate-edit-success
   [{:keys [db]} [_ which {:keys [task-config-id] :as edit}]]
   (let [edits (comparate-edits db which edit)]
     (on-load-comparate-edit-success db task-config-id edits))))

(rf/reg-event-fx
 ::re-load-comparate-edit-success
 (fn re-load-comparate-edit-success
   [{:keys [db]} [_ {:keys [which which-other-edit other-edit-id]} {:keys [item-id task-config-id] :as edit}]]
    ;; Show differences against the other comparate edit in its current unsubmitted state.
   (let [other-intermediate-edit (annotation-db/intermediate-edit db item-id other-edit-id)
         edits (-> (comparate-edits db which edit)
                   (update which-other-edit merge other-intermediate-edit))]
     (on-load-comparate-edit-success db task-config-id edits))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;; Compare Answer Item Group ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-controller ::compare-item-group
                   {:params (fn [{:keys [handler] :as params}]
                              (when (= handler ::compare-item-group)
                                params))
                    :start (fn [_ {{:keys [item-group-id user-a user-b]} :route-params :as active}]
                             (when active
                               [::load-comparate-item-groups item-group-id user-a user-b]))})

(rf/reg-event-fx
 ::load-comparate-item-groups
 (fn load-comparate-item-group
   [{:keys [db]} [_ item-group-id user-a user-b]]
   {:db (-> db
            (db/set-qa-loading true)
            (db/clear-comparate-item-groups))
    :dispatch-n [[::load-item-group user-a item-group-id [::load-comparate-item-group-success :user-a]]
                 [::load-item-group user-b item-group-id [::load-comparate-item-group-success :user-b]]]}))

(rf/reg-event-fx
 ::load-comparate-item-group-success
 (fn load-comparate-item-group-success
   [{:keys [db]} [_ which-user item-group]]
   {:db (db/set-comparate-item-group db which-user item-group)
    :dispatch [::load-comparate-item-groups-success]}))

(rf/reg-event-fx
 ::load-comparate-item-groups-success
 (fn load-comparate-item-groups-success
   [{:keys [db]} [_]]
   (let [item-groups (db/get-comparate-item-groups db)
         loading? (or (nil? item-groups)
                      (and (not= 2
                                 (count item-groups))
                           (not-every? item-groups [:user-a :user-b])))]
     {:db (db/set-qa-loading db loading?)})))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Actions ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(kf/reg-event-fx
 ::send-qa-edit-success
 (fn send-qa-edit-success
   [{:keys [db]} [dispatch-final dispatch-n {{:keys [user-id id] :as edit} :edit}]]
   {:db db
    :dispatch-n (conj (or dispatch-n [])
                      [::notifications/add-alert annotation-ids/annotation-alert-banner
                       {:message "Annotation saved successfully"
                        :type :info}
                       :auto-dismiss? true]
                      [::session/log-events {:events [{:event-type :submit
                                                       :info {:type :admin-edit
                                                              :admin-id (user-db/get-user-id db)
                                                              :annotator-id user-id}
                                                       :data (assoc edit :edit-id id)}]}]
                      [::annotation-handlers/set-loading? false]
                      dispatch-final)}))

(rf/reg-event-fx
 ::submit-feedback
 (fn submit-feedback
   [_ [_ {{:keys [user-id item-id]} :edit :as feedback}]]
   {:http-xhrio {:method :post
                 :uri (kf/path-for [:api/user-item-feedback
                                    :item-id item-id
                                    :user-id user-id])
                 :params feedback
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::submit-feedback-success]
                 :on-failure [::submit-feedback-failure]}
    :dispatch [::session/log-events {:events [{:event-type :feedback-submitted
                                               :data feedback}]}]}))

(rf/reg-event-fx
 ::submit-feedback-success
 (fn submit-feedback-success
   [_ _]
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Feedback saved successfully"
                :type :info}
               :auto-dismiss? true]}))

(rf/reg-event-fx
 ::submit-feedback-failure
 (fn submit-feedback-failure
   [_ _]
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Unable to save feedback"
                :type :error}
               :auto-dismiss? true]}))

(rf/reg-event-fx
 ::approve-edit
 (fn approve-edit
   [_ [_ {:keys [item-group-id] :as item} edit]]
   {:http-xhrio {:method :put
                 :uri (kf/path-for [:api/approve-edits])
                 :params {item-group-id {:status (if (= (:status edit) :requires-approval) :done :rejected)}}
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::approve-edit-success item edit]
                 :on-failure [::approve-edit-failure]}}))

(rf/reg-event-fx
 ::approve-edit-success
 (fn approve-edit-success
   [_ [_ {item-id :id :as _item} edit]]
   {:fx [[:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
                     {:message "Edit has been approved"
                      :type :info}
                     :auto-dismiss? true]]
         [:dispatch [::load-edit (:user-id edit) (str item-id)]]]}))

(rf/reg-event-fx
 ::approve-edit-failure
 (fn approve-edit-failure
   [_ _]
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Unable to approve edit"
                :type :error}
               :auto-dismiss? true]}))

(kf/reg-event-fx
 ::approve-multi
 (fn approve-multi
   [_ [edits]]
   {:http-xhrio {:method :put
                 :uri (kf/path-for [:api/approve-edits])
                 :params (into {} (->> edits
                                       (map (fn [edit] [(:item-group-id edit)
                                                        {:status (if (= (:status edit) :requires-approval) :done :rejected)}]))))
                 :format (edn-request-format)
                 :response-format (edn-response-format)
                 :on-success [::approve-edits-success]
                 :on-failure [::approve-edits-failure]}
    :dispatch [::modal/hide annotation-ids/approve-multi-modal]}))

(rf/reg-event-fx
 ::approve-edits-success
 (fn approve-edit-success
   [_ [_ _params]]
   {:fx [[:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
                     {:message "Edits have been approved"
                      :type :info}
                     :auto-dismiss? true]]
         [:dispatch [::edit-handlers/load-edits]]]}))

(rf/reg-event-fx
 ::approve-edits-failure
 (fn approve-edit-failure
   [_ _]
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Unable to approve edits"
                :type :error}
               :auto-dismiss? true]}))

(rf/reg-event-fx
 ::assign-to-me
 (fn assign-to-me
   [_ [_ params]]
   (let [item-group-id (get-in params [:item :item-group-id])
         user-id (get-in params [:user :id])]
     {:http-xhrio {:method :put
                   :uri (kf/path-for [:api/re-assign
                                      :item-group-id item-group-id
                                      :user-id user-id])
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::assign-to-me-success params]
                   :on-failure [::assign-to-me-failure]}})))

(rf/reg-event-fx
 ::assign-to-me-success
 (fn assign-to-me-success
   [_ _]
   {:fx [[:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
                     {:message "Item has been reassigned to you"
                      :type :info}
                     :auto-dismiss? true]]]}))

(rf/reg-event-fx
 ::assign-to-me-failure
 (fn assign-to-me-failure
   [_ _]
   {:dispatch [::notifications/add-alert annotation-ids/annotation-alert-banner
               {:message "Unable to reassign item"
                :type :error}
               :auto-dismiss? true]}))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Misc ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-db
 ::set-qa-loading
 (fn set-qa-loading
   [db [_ loading?]]
   (db/set-qa-loading db loading?)))

(rf/reg-event-db
 ::set-submission-type
 (fn set-submission-type
   [db [_ submission-type]]
   (db/set-submission-type db submission-type)))

(rf/reg-event-db
 ::set-aihyb-filter
 (fn [db [_ filter]]
   (prn ::set-aihyb-filter filter)
   (db/set-aihyb-filter db filter)))
